export function getYearsAffiliated(affiliateEffectiveDate: string): number {
  const effectiveDate = new Date(affiliateEffectiveDate)
  const today = new Date()

  let years = today.getFullYear() - effectiveDate.getFullYear()
  const monthDifference = today.getMonth() - effectiveDate.getMonth()
  const dayDifference = today.getDate() - effectiveDate.getDate()

  /*
	  If the current month is earlier than the effective month,
	  or it's the same month but the current day is earlier than the effective day,
	  subtract one year from the difference
	*/
  if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
    years--
  }

  return years
}
